<script>
import forEach from 'lodash/forEach'
import RelatedProjectItem from './RelatedProjectItem'
import { resizeImage } from '~/util/img.util'
import { searchProjectList } from '~/api/project.api'
export default {
  components: {
    RelatedProjectItem
  },
  data() {
    return {
      relatedProject: [],
      isLoading: false,
      isLastPage: false,
      isBigScreen: true,
      imageWidth: 0,
      imageHeight: 0
    }
  },
  mounted() {
    this.getImageWidthAndHeight()
    this.getSearchProjectList()
  },
  methods: {
    getSearchProjectList,
    getImageWidthAndHeight
  }
}

function getImageWidthAndHeight() {
  if (this.$_thebox.clientWidth > 940) {
    this.isBigScreen = true
    this.imageWidth = this.$_thebox.clientWidth / 2
    this.imageHeight = (this.imageWidth / 7) * 5
  } else {
    this.isBigScreen = false
    this.imageWidth = (940 - 90) / 4
    this.imageHeight = (this.imageWidth / 7) * 5
  }
}

async function getSearchProjectList() {
  const vm = this
  const res = await searchProjectList({
    sort: 7,
    projectId: this.$route.params.projectId,
    pageNo: 1,
    pageSize: 4,
    companyId: this.$route.params.companyId
  })
  forEach(res, (item) => {
    if (item.projectImgOssUrl) {
      item.projectImgOssUrl = resizeImage({
        src: item.projectImgOssUrl,
        width: vm.imageWidth,
        height: vm.imageHeight,
        defaultImg: 'project'
      })
    } else {
      item.projectImgOssUrl = resizeImage({
        src: this.defaultProjectImg,
        width: vm.imageWidth,
        height: vm.imageHeight
      })
    }
  })
  this.relatedProject = res
}
</script>
<template>
  <ul class="related_project_container">
    <li
      v-for="(project, index) in relatedProject"
      :key="index"
      class="related_project_container_item_container"
    >
      <nuxt-link :to="`../${project.projectId}`" :target="$_newtab" append>
        <div class="single_related_project_container">
          <!-- 单个item -->
          <RelatedProjectItem :project-item="project" />
        </div>
      </nuxt-link>
    </li>
  </ul>
</template>
<style lang="scss">
.related_project_container {
  list-style: none;
}

.gs_one_line {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
//only pc
@media screen and (min-width: 940px) {
  .related_project_container {
    float: left;

    li {
      display: inline-block;
      width: calc((100% - 90px) / 4);
    }
  }

  .single_related_project_container {
    width: calc((100% - 90px) / 4);
    padding-right: 30px;
    .project_title {
      font-size: 18px;
      line-height: 18px;
    }
    ul {
      li {
        font-size: 14px;
        line-height: 14px;
      }
    }
  }
}
//only mobile
@media screen and (max-width: 940px) {
  .single_related_project_container {
    padding-left: 0px;
    padding-right: 15px;
    padding-top: 10px;
    .project_title {
      font-size: 16px;
      line-height: 16px;
    }
    ul {
      li {
        font-size: 12px;
        line-height: 12px;
      }
    }
  }

  .related_project_container_item_container {
    display: inline-block;
    width: calc((100%) / 2) !important;
  }
}

.single_related_project_container {
  border-radius: 5px;
  * {
    margin: 0;
    padding: 0;
  }

  .img_mark_container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  width: 100%;
  display: flex;
  flex-direction: column;

  .project_title {
    color: rgba(0, 0, 0, 1);
    padding-top: 15px;
    padding-bottom: 10px;
  }

  .top_container {
    position: relative;

    .icon_container {
      bottom: 15px;
      display: flex;
      position: absolute;
      margin-left: 5px;

      %icon_common {
        width: 30px;
        height: 30px;
        margin-left: 10px;
      }
      .icon_video {
        @extend %icon_common;
        left: 15px;
      }

      .icon_vr {
        @extend %icon_common;
        left: 55px;
      }
    }

    span {
      position: absolute;
      display: inline-block;
      font-size: 16px;
      color: rgba(42, 42, 42, 1);
      line-height: 16px;
      background: rgba(255, 255, 255, 0.95);
      border-radius: 2px;
      top: 15px;
      left: 15px;
      padding: 4px 10px;
    }

    .project_image {
      width: 100%;
      border-radius: 5px;
    }
  }

  ul {
    li {
      display: inline;
      list-style: none;
      font-weight: 400;
      color: rgba(68, 68, 68, 1);
    }
  }
}
</style>
